export const LedgerCategory = {
    LabourAdvanceOn: 'ADVANCEON',
    LabourAdvanceOff: 'ADVANCEOFF',
    LabourAdvanceCategory: ['ADVANCEON', 'ADVANCEOFF'],
    ExtrasCategory: ['QION', 'QIOFF', 'CEBONUS'],
    WashupCategory: ['EOTPON', 'EOTPOFF'],
    EndOfTripCategory: [
        'DAILYRATEON',
        'DAILYRATEOFF',
        'FISHSHAREON',
        'FISHSHAREOFF',
        'COSTON',
        'COSTOFF',
        'WORKBY'
    ],
    GrossCategory: [
        'DAILYRATEON',
        'DAILYRATEOFF',
        'FISHSHAREON',
        'FISHSHAREOFF',
    ],
    CostsCategory: [
        'COSTON',
        'COSTOFF',
    ]
};
export const VesselTypes={
    InShore: 'INSHORE',
    DeepWater: 'DEEP WATER',
    DeepWaterScampi: 'DEEP WATER SCAMPI'
};
export const VesselTypesOptions = [
    { value: VesselTypes.InShore, label: VesselTypes.InShore },
    { value: VesselTypes.DeepWater, label: VesselTypes.DeepWater },
    { value: VesselTypes.DeepWaterScampi, label: VesselTypes.DeepWaterScampi },
]
export const webJobIdAndFishingTripNumberDictionaryStorageName = 'WEB-JOB-ID-AND-FT-NUMBER';
export const eotGeneratingToastIdStorageName = 'EOT-GENERATING-TOAST-ID';

export enum WorkByEntryType{
    Normal = 'Normal',
    Additional = 'Additional',
    SeaDay = 'SD',
}

export enum WorkByRecordStatus{
    Created = 1,
    Submitted = 2,
    Approved = 3,
}

export const WorkByModifiedBy = 'Integration';